import request from '../config/axiosConfig';
import { GET_LIST_AUDIENCE, GET_LIST_BANNER_PAGE, GET_LIST_CAMPAIGN_LICH_VIET, GET_LIST_POPUP_PAGE, GET_TOKEN_TO_UPLOAD, GET_TOPIC } from '../constants/apiEndPoint';

export const getListAudienceRequest = async (params) => {
  const result = await request({
    url: GET_LIST_AUDIENCE,
    method: 'POST',
    data: params,
  });
  return result?.data?.data?.data;
};

export const getListBannerPageRequest = async (params) => {
  const result = await request({
    url: GET_LIST_BANNER_PAGE,
    method: 'POST',
    data: params,
  });
  return result?.data?.data?.data;
};

export const getListPopupPageRequest = async (params) => {
  const result = await request({
    url: GET_LIST_POPUP_PAGE,
    method: 'POST',
    data: params,
  });
  return result?.data?.data?.data;
};

export const getListCampaignsCMSNextRequest = async (params) => {
  const result = await request({
    url: GET_LIST_CAMPAIGN_LICH_VIET,
    method: 'POST',
    data: params,
  });
  return result?.data?.data?.data;
};

export const getListVersionAndTopicRequest = async (params) => {
  const result = await request({
    url: GET_TOPIC,
    method: 'POST',
    data: params,
  });
  return result?.data?.data?.data;
};

export const getTokenToUploadRequest = async (data) => {
  const result = await request({
    url: GET_TOKEN_TO_UPLOAD,
    method: 'POST',
    data,
  });
  return result?.data;
};